module.exports = __webpack_public_path__ + "img/Deathknight-dwarf-f-70.f8b21f85.gif";